import { ListNsnCandidatesResponse } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useMutation } from '@tanstack/react-query';

export const useFindNsnCandidates = () => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (partNumber: string): Promise<ListNsnCandidatesResponse> => {
      const response = await api.tenants.listNsnCandidates(tenantId, partNumber);
      return response.data;
    },
  });

  return { findNsnCandidates: mutateAsync, isPending };
};
